import { render } from "./vsi_platform_section.html?vue&type=template&id=4b4d1aa4&external"
import script from "./vsi_platform_section.js?vue&type=script&lang=js&external"
export * from "./vsi_platform_section.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__